module.exports = __webpack_public_path__ + "img/112ne.7f7c9e46.svg";